import React, { ReactElement } from 'react'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    dense?: boolean
    actions?: React.ReactNode
    hasBorder?: boolean
}

export const Card = ({ dense = false, actions, hasBorder = false, children, ...props }: CardProps): ReactElement => {
    const getPaddingClasses = (): string => {
        if (dense && actions) return 'pl-3 py-1 pr-1'
        if (dense && !actions) return 'p-3'
        return 'p-4'
    }

    const borderClasses = hasBorder ? 'border border-border-default' : 'shadow-drop-sm'

    return (
        <div {...props} className={`bg-primary ${borderClasses} flex ${getPaddingClasses()} ${props.className}`}>
            <div className="grow min-w-0">{children}</div>
            {actions && <div className="inline-flex shrink-0 items-center gap-0.5">{actions}</div>}
        </div>
    )
}
